"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPolygonPath = void 0;
const constants_1 = require("../../constants");
const utility_paths_1 = require("../utility.paths");
function getPolygonPath(polygonShape) {
    const width = constants_1.SvgDefaults.viewBoxWidth;
    let path = '';
    let coordinates = [];
    const numberOfSides = polygonShape.numberOfSides;
    coordinates = utility_paths_1.getRegularPolygonCoordinates(numberOfSides, width / 2);
    const radius = polygonShape.borderRadius;
    if (radius) {
        path = utility_paths_1.getRoundedPolygon(coordinates, radius);
    }
    else {
        path = utility_paths_1.generatePathFromCoordinates(coordinates);
    }
    return path;
}
exports.getPolygonPath = getPolygonPath;
//# sourceMappingURL=polygon.js.map